import i18n from '@/i18n/config';
import { reviews as reviewsZhTW } from './reviews.zh-TW';
import { reviews as reviewsEn } from './reviews.en';

export interface Review {
  name: string;
  title: string;
  content: string;
  rating: number;
  reply: string;
  date: string;
}

// Export reviews based on current language
const getReviews = (): Review[] => {
  const currentLanguage = i18n.language || 'zh-TW';

  switch (currentLanguage) {
    case 'en':
      return reviewsEn;
    case 'zh-TW':
    default:
      return reviewsZhTW;
  }
};

export const reviews = getReviews();

// Export function to reactively get reviews when language changes
export const getReviewsByLanguage = (language: string): Review[] => {
  switch (language) {
    case 'en':
      return reviewsEn;
    case 'zh-TW':
    default:
      return reviewsZhTW;
  }
};
